export const ICON_NAMESPACE = 'es-layout';
